/* eslint-disable no-undef */
export default class IMAPlayerView {
  constructor(idComponent) {
    this.idComponent = idComponent;
  }

  getAdContainer(idAdContain) {
    const idAdContainer = idAdContain || 'adContainer';
    this.idContainerName = idAdContainer;
    this.querySelectorForViewability = `#${this.idContainerName}>div`;
    let adContainer = document.getElementById(this.idComponent).querySelector(`#${idAdContainer}`);
    if (!adContainer) {
      this.createAdContainer(idAdContainer);
      adContainer = document.getElementById(this.idComponent).querySelector(`#${idAdContainer}`);
    } else if (adContainer) {
      adContainer.innerHTML = '';
      adContainer.style.display = 'block';
      setTimeout(() => {
        adContainer.style.display = 'block';
      }, 500);
      setTimeout(() => {
        adContainer.style.display = 'block';
      }, 1500);
    }
    return adContainer;
  }

  createAdContainer(idAdContainer) {
    const cont =
      document
        .getElementById(this.idComponent)
        .querySelector('#video-ext-container>.tpx-ext-control-bar') ||
      document.getElementById(this.idComponent);

    const adContainer = document.createElement('div');
    adContainer.id = idAdContainer; // 'adContainer'

    if (cont) cont.appendChild(adContainer);
  }

  getPlayerContent() {
    this.playerContent = document.querySelector('#video-player-container>video');

    /* let myVideo = document.createElement('video');
    myVideo.id= Math.random();
    myVideo.setAttribute('src', PlayerConstants.VIDEO_DEFAULT);
    playerContent.appendChild(myVideo);
    */
    // se ha comentado la siguiente línea porque hace que se vea el video antes de iniciarse la publicidad
    // if (typeof playerContent !== 'undefined') playerContent.style.display = 'block'; // nos aseguramos que esté visible antes de empezar la reproduccion. puede que no esté visible si se ha reproducido un audio
    // const playerContent = document.getElementById(this.idComponent);
    return this.playerContent;
  }

  /*----------------*/

  remove() {
    const adContainer = document
      .getElementById(this.idComponent)
      .querySelector(`#${this.idContainerName}`);
    if (adContainer) {
      adContainer.style.display = 'none';
      adContainer.style.zIndex = null;
    }
    setTimeout(() => {
      const cont =
        document
          .getElementById(this.idComponent)
          .querySelector('#video-ext-container>.tpx-ext-control-bar') ||
        document.getElementById(this.idComponent);

      if (cont && adContainer) cont.removeChild(adContainer);
    }, 1000);
  }

  showAdContainer() {
    const adContainer = document
      .getElementById(this.idComponent)
      .querySelector(`#${this.idContainerName}`);
    if (adContainer) {
      adContainer.style.display = 'block';
      adContainer.style.zIndex = '2';
    }
  }
}
